'use client';

import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hook';
import { setCredentials, markHydrated } from '@/features/auth/authSlice';
import type { LoginApiReturnData } from '@/types/auth';

export default function AuthInitializer() {
  const dispatch = useAppDispatch();
  const hydrated = useAppSelector((state) => state.auth.hydrated);

  useEffect(() => {
    if (hydrated) return;

    try {
      const raw = localStorage.getItem('meInfo');
      if (raw) {
        const parsed = JSON.parse(raw) as LoginApiReturnData;

        if (parsed?.token) {
          dispatch(
            setCredentials({
              meInfo: parsed, // ✅ 這裡就是 LoginApiReturnData
              token: parsed.token ?? null, // ✅ 拿出來塞到 auth.token
              refreshToken: parsed.refreshToken ?? null,
            })
          );
        }
      }
    } catch (err) {
      console.warn('Failed to read meInfo:', err);
    } finally {
      dispatch(markHydrated());
    }
  }, [dispatch, hydrated]);

  return null;
}
